<template>
  <el-dialog class="modal test" :width="size" :top="top" :class="customClass" :show-close="false" :visible.sync="isOpen" @closed="close">
    <template v-if="component">
      <component :is="component" :meta="meta"></component>
    </template>
  </el-dialog>
</template>
<script>
import Vue from 'vue'
import { Dialog } from 'element-ui'
Vue.use(Dialog)

export default {
  name: 'ModalLayout',
  props: {
    component: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: '50%',
    },
    customClass: {
      type: String,
      default: '',
    },
    meta: {
      type: null,
      default: null,
    },
    top: {
      type: String,
      default: '15vh',
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        document.body.classList.add('overflow-hidden')
        this.$emit('modal:open', { event: 'modal:open', value: this.isOpen })
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isOpen = true
    }, 0)
  },
  methods: {
    close() {
      this.$emit('modal:close', { event: 'modal:close', value: this.isOpen })
      this.$Modal.destroy()
    },
  },
}
</script>
<style lang="scss">
.modal {
  .el-dialog__header {
    @apply p-0;
  }
  .el-dialog__body {
    @apply p-0;
  }
}
</style>
